import { createAction, props } from '@ngrx/store';
import { Parcel } from '../_models';

// Action types
export const loadParcels = createAction('[Parcel] Load Parcels', props<{ year: number }>());
export const loadParcelsSuccess = createAction(
  '[Parcel] Load Parcels Success',
  props<{ parcels: Parcel[] }>()
);
export const loadParcelsFailure = createAction(
  '[Parcel] Load Parcels Failure',
  props<{ error: any }>()
);

export const addParcel = createAction('[Parcel] Add Parcel', props<{ parcel: Parcel }>());
export const addParcelSuccess = createAction(
  '[Parcel] Add Parcel Success',
  props<{ parcel: Parcel }>()
);
export const addParcelFailure = createAction(
  '[Parcel] Add Parcel Failure',
  props<{ error: any }>()
);

export const updateParcel = createAction('[Parcel] Update Parcel', props<{ parcel: Parcel }>());
export const updateParcelSuccess = createAction(
  '[Parcel] Update Parcel Success',
  props<{ parcel: Parcel }>()
);
export const updateParcelFailure = createAction(
  '[Parcel] Update Parcel Failure',
  props<{ error: any }>()
);

export const deleteParcel = createAction('[Parcel] Delete Parcel', props<{ id: number }>());
export const deleteParcelSuccess = createAction(
  '[Parcel] Delete Parcel Success',
  props<{ id: number }>()
);
export const deleteParcelFailure = createAction(
  '[Parcel] Delete Parcel Failure',
  props<{ error: any }>()
);
